import { gql } from '@apollo/client'

export const GET_ROOMS = gql`
  query GetRooms($group: String, $loc: String) {
    rooms(group: $group, loc: $loc) {
      room_id
      name
      description
      location_id
      location_data_id
      room_group_id
      room_group_name
      elektra_scene_idx
      color
    }
  }
`
